import { User } from "@auth0/auth0-angular";
import { MembersByUser, MembersByUserResponse } from "@rr/shared-data-access-api";
import { ThemeConfig } from "../../models";

export interface AuthState {
  isLoading: boolean;
  token: string | null;
  user: UserInfo | null;
  memberUser: MemberUserProfile | null;
  theme: ThemeConfig | null;
  pendingSwitchOrg: MembersByUser | null;
  callback: (() => void) | null;
}

export interface MemberUserProfile extends MembersByUserResponse {
  primaryOrganization: MembersByUser | null;
}

export const initialState: AuthState = {
  isLoading: false,
  token: null,
  user: null,
  memberUser: null,
  theme: null,
  pendingSwitchOrg: null,
  callback: null,
};

export interface UserInfo extends User {
  agAppId?: string | null;
  agOrgId?: string | null;
  agOrgName?: string | null;
  agOrgNameSmall?: string | null;
  agUserId?: string | null;
  org_id?: string | null;
  org_name?: string | null;
}
